/* @ngInject */
export function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider
        .otherwise(defaultRouteHandler)
        .deferIntercept();
}

/* @ngInject */
export function defaultRouteHandler($injector) {
    const $state = $injector.get('$state');
    return $state.go('identity.sign-in');
}

/* @ngInject */
export function bootstrapApplication($urlRouter, sessionService, preferenceService, themeService) {
    return sessionService.initialize().finally(() => {
        const storedTheme = themeService.getStoredTheme();

        if (!sessionService.user) {
            themeService.applyTheme(storedTheme || 'system');
            $urlRouter.sync();
            $urlRouter.listen();
            return;
        }

        preferenceService.get().then((preferences) => {
            const theme = preferences && preferences.theme ? preferences.theme : storedTheme || 'system';
            themeService.applyTheme(theme);

            if ((!preferences || !preferences.theme) && !storedTheme) {
                const nextPreferences = preferences || {};
                nextPreferences.theme = 'system';
                preferenceService.save(nextPreferences).catch(() => null);
            }
        }).catch(() => {
            themeService.applyTheme(themeService.getStoredTheme() || 'system');
        });

        $urlRouter.sync();
        $urlRouter.listen();
    }).catch(() => null);
}



// WEBPACK FOOTER //
// ./src/application/index.config.js